import { call, put, takeLatest, all } from 'redux-saga/effects';
import axios from 'axios';
import * as Actions from '../../actions';
import { showToast } from 'app/store/actions/fuse';

function* fetchResourceOperations(action) {
    const { resourceId } = action.payload;
	try {
        const response = yield call(() => axios.get(`/api/v1/resources/${resourceId}/operations`));
		yield put(Actions.fetchResourceOperationsSuccess(response.data));
	} catch (error) {
		yield put(Actions.fetchResourceOperationsFailure());
		showToast.error('Unable to Retrieve Resource Operations: ' + error);
	}
}

function* reorderOperations(action) {
	const { operations } = action.payload;

	try {
		yield call(() => axios.patch('/api/v1/operations?opPatchOperation=UpdateList', operations));
		yield put(Actions.reorderOperationsSuccess(operations));

		showToast.success('Operations Order Updated');
	} catch (error) {
		yield put(Actions.reorderOperationsFailure());

		showToast.success('Unable Reorder Operations: ' + error);
	}
}

function* watchOperations() {
	yield all([takeLatest(Actions.fetchResourceOperations, fetchResourceOperations)]);
	yield all([takeLatest(Actions.reorderOperations, reorderOperations)]);
}

export default watchOperations;